/**
 * Holds the one client secret a handoff-code visit is allowed to have.
 *
 * The code is single-use, so the page redeems it once, up front, to decide what
 * to show. Stripe's `fetchClientSecret` is then called by the Connect instance
 * to start the session and again whenever it needs to refresh an expired one.
 * The first call hands back the secret already in hand; every later call has
 * nothing left to mint, which is reported through `onExhausted` so the page can
 * say so instead of leaving the components to fail on their own.
 */
export const createOneShotSecret = (onExhausted) => {
  let secret;
  return {
    store: (value) => {
      secret = value;
    },
    fetchClientSecret: async () => {
      const handedOut = secret;
      secret = undefined;
      if (!handedOut) {
        onExhausted();
      }
      return handedOut;
    },
  };
};
